import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
});

export const overrides = {
	'.FilterSet-root': {
		position: 'relative',
		marginTop: remCalc(50),
		marginBottom: remCalc(50),
		// border: `1px solid ${getColor('ivory', 500)}`,
		backdropFilter: 'blur(30px)',
		boxShadow: '0 0 4px rgba(0,0,0,0.15)',
		backgroundColor: getColor('white', 100),
		paddingTop: remCalc(40),
		paddingBottom: remCalc(40),
		paddingLeft: remCalc(24),
		paddingRight: remCalc(24),
		zIndex: theme.zIndex.modal - 1,
		[theme.breakpoints.up('md')]: {
			paddingLeft: remCalc(48),
			paddingRight: remCalc(48),
		},

		'.FilterSet-title': {
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(25),
			lineHeight: remCalc(32),
			color: getColor('ivory', 700),
			letterSpacing: '-0.25px',
			marginBottom: remCalc(30),
			textTransform: 'uppercase',
		},

		'.FilterSet-searchRow': {
			display: 'flex',
			alignItems: 'center',
			gap: remCalc(20),
			flexDirection: 'column',
			justifyContent: 'space-between',
			[theme.breakpoints.up('sm')]: {
				flexDirection: 'row',
				alignItems: 'stretch',
				gap: remCalc(60),
			},
		},

		'.FilterSet-searchWrap': {
			flex: '1 1 auto',
			display: 'flex',
			border: `1px solid ${getColor('ivory', 500)}`,
			minHeight: remCalc(58),
			width: '100%',
			// maxWidth: remCalc(556),
			[theme.breakpoints.up('sm')]: {
				width: 'auto',
			},
		},

		'.FilterSet-searchInput': {
			flex: '1 1 auto',
			backgroundColor: 'transparent',
			border: 'none',
			padding: `0 ${remCalc(20)}`,
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(16),
			fontWeight: 420,
			letterSpacing: '2px',
			textTransform: 'uppercase',
			color: getColor('ivory', 700),
			'&:focus-visible': {
				outline: 'none',
			},
			'::placeholder': {
				color: getColor('ivory', 700),
			},
		},

		'.FilterSet-searchButton': {
			flex: '0 0 auto',
			border: 'none',
			cursor: 'pointer',
			backgroundColor: getColor('ivory', 700),
			color: getColor('ivory', 400),
			width: remCalc(58),
			minWidth: remCalc(58),
			'> svg': {
				fill: getColor('ivory', 400),
			}
		},

		'.FilterSet-groupToggles': {
			display: 'flex',
			alignItems: 'center',
			gap: remCalc(20),
			flexWrap: 'wrap',
			position: 'relative',
			width: '100%',
			[theme.breakpoints.up('sm')]: {
				justifyContent: 'flex-start',
				width: 'auto',
			},
		},

		'.FilterSet-groupTogglesWrap': {
			display: 'flex',
			flexDirection: 'column',
			gap: remCalc(40),
			justifyContent: 'space-between',
			'.FilterSet-groupTogglesTitle': {
				textTransform: 'uppercase',
				fontWeight: 400,
			},
		},

		'.FilterSet-clearWrap': {
			display: 'flex',
			alignItems: 'center',
			gap: remCalc(20),
			flexWrap: 'wrap',
			position: 'relative',
			width: '100%',
			[theme.breakpoints.up('sm')]: {
				justifyContent: 'flex-start',
				width: 'auto',
			},
		},

		'.FilterSet-dropdown': {
			position: 'relative',
			display: 'inline-flex',
			flexDirection: 'column',
			width: '100%',
			[theme.breakpoints.up('sm')]: {
				width: 'auto',
			},
		},

		'.FilterSet-button': {
			position: 'relative',
			flex: '0 0 auto',
			minHeight: remCalc(58),
			border: `1px solid ${getColor('ivory', 500)}`,
			backgroundColor: 'transparent',
			// backgroundColor: getColor('ivory', 400),
			color: getColor('ivory', 700),
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(16),
			fontWeight: 420,
			letterSpacing: '2px',
			textTransform: 'uppercase',
			padding: `0 ${remCalc(20)}`,
			cursor: 'pointer',
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			gap: remCalc(14),
			'svg': {
				width: remCalc(18),
			},
			'&:hover:not(.FilterSet-filter-isDisabled)': {
				textDecoration: 'underline',
			},
			'&.FilterSet-button-isActive': {
				backgroundColor: getColor('ivory', 400),
			},
		},

		'.FilterSet-toggleButton': {
			flex: '0 0 auto',
			minHeight: remCalc(58),
			border: `1px solid ${getColor('ivory', 500)}`,
			backgroundColor: getColor('white', 100),
			color: getColor('ivory', 700),
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(16),
			fontWeight: 420,
			letterSpacing: '2px',
			textTransform: 'uppercase',
			padding: `0 ${remCalc(20)}`,
			cursor: 'pointer',
			display: 'inline-flex',
			alignItems: 'center',
			gap: remCalc(14),
			justifyContent: 'space-between',
			// '&:disabled': {
			// 	opacity: 0.6,
			// 	cursor: 'default',
			// },
			'> span:first-of-type': {
				whiteSpace: 'nowrap',
			},
			'.FilterSet-toggleChevron': {
				width: remCalc(9),
				height: remCalc(9),
				borderRight: `1px solid ${getColor('ivory', 800)}`,
				borderBottom: `1px solid ${getColor('ivory', 800)}`,
				transform: 'rotate(45deg) translateY(-10%)',
				transition: 'transform var(--transition-duration) ease',
				display: 'inline-block',
				marginLeft: "auto",
			},
			'.FilterSet-toggleCount': {
				minWidth: remCalc(20),
				height: remCalc(20),
				borderRadius: '50%',
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
				fontSize: remCalc(12),
				fontWeight: 420,
				backgroundColor: getColor('ivory', 400),
				color: getColor('ivory', 800),
			},
			[theme.breakpoints.up('md')]: {
				minWidth: remCalc(272),
			},
			'&.FilterSet-toggleOpen': {
				backgroundColor: getColor('ivory', 400),
				'.FilterSet-toggleChevron': {
					transform: 'rotate(-135deg) translateY(-10%)',
				},
			},
		},

		'.FilterSet-date-wrapper': {
	        position: 'relative',
	        flexGrow: 1,

	        '&.FilterSet-hasValue': {
	        	'.FilterSet-date-label': {
	        		borderRadius: remCalc(4),
	        		border: `1px solid ${getColor('ivory', 500)}`,
	        		background: getColor('ivory', 400),
	        		padding: remCalc('5 10'),
	        	}
	        },
		},
	    

		'.FilterSet-date-options': {
			marginTop: remCalc(12),
			border: `1px solid ${getColor('ivory', 500)}`,
			backgroundColor: getColor('white', 100),
			boxShadow: '0 4px 4px rgba(0,0,0,0.15)',
			padding: remCalc(32),
			width: '100%',
			maxHeight: remCalc(400),
			overflowY: 'auto',
			zIndex: theme.zIndex.modal - 1,
			display: 'flex',
			flexDirection: 'column',
			gap: remCalc(20),
			'.FilterSet-applyButton': {
				position: 'relative',
				flex: '0 0 auto',
				minHeight: remCalc(58),
				border: `1px solid ${getColor('ivory', 400)}`,
				backgroundColor: getColor('ivory', 400),
				color: getColor('ivory', 700),
				fontFamily: 'var(--font-brandon-grotesque)',
				fontSize: remCalc(16),
				fontWeight: 420,
				letterSpacing: '2px',
				textTransform: 'uppercase',
				padding: `0 ${remCalc(20)}`,
				cursor: 'pointer',
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
				gap: remCalc(14),
				'svg': {
					width: remCalc(18),
				},
				'&:hover': {
					textDecoration: 'underline',
				}
			},
			[theme.breakpoints.up('sm')]: {
				position: 'absolute',
				top: `calc(100% + ${remCalc(12)})`,
				left: 0,
				marginTop: 0,
				width: 'max-content',
				minWidth: '100%',
				maxWidth: remCalc(460),
			},
			'&::-webkit-scrollbar': {
				width: remCalc(5),
				backgroundColor: getColor('white', 100),
			},
			'&::-webkit-scrollbar-thumb': {
				backgroundColor: getColor('ivory', 700),
			},
		},

		'.FilterSet-clear': {
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(16),
			fontWeight: 420,
			lineHeight: remCalc(20),
			letterSpacing: '2px',
			textTransform: 'uppercase',
			border: 'none',
			backgroundColor: 'transparent',
			color: getColor('ivory', 600),
			padding: 0,
			cursor: 'pointer',
			'&:disabled': {
				opacity: 0.6,
				cursor: 'default',
			},
		},

		'.FilterSet-panel': {
			marginTop: remCalc(12),
			border: `1px solid ${getColor('ivory', 500)}`,
			backgroundColor: getColor('white', 100),
			boxShadow: '0 4px 4px rgba(0,0,0,0.15)',
			padding: remCalc(32),
			width: '100%',
			maxHeight: remCalc(400),
			overflowY: 'auto',
			zIndex: theme.zIndex.modal - 1,
			[theme.breakpoints.up('sm')]: {
				position: 'absolute',
				top: `calc(100% + ${remCalc(12)})`,
				left: 0,
				marginTop: 0,
				width: 'max-content',
				minWidth: '100%',
				maxWidth: remCalc(460),
			},
			'&::-webkit-scrollbar': {
				width: remCalc(5),
				backgroundColor: getColor('white', 100),
			},
			'&::-webkit-scrollbar-thumb': {
				backgroundColor: getColor('ivory', 700),
			},
		},

		'.FilterSet-options': {
			display: 'flex',
			flexDirection: 'column',
			gap: remCalc(20),
		},

		'.FilterSet-option': {
			position: 'relative',
			display: 'inline-flex',
			alignItems: 'center',
			gap: remCalc(10),
			cursor: 'pointer',
			width: '100%',
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(16),
			fontWeight: 390,
			lineHeight: remCalc(22),
			letterSpacing: '0.32px',
			textTransform: 'capitalize',
			color: getColor('ivory', 700),
			'.FilterSet-optionInput': {
				position: 'absolute',
				opacity: 0,
				width: remCalc(1),
				height: remCalc(1),
				margin: 0,
				pointerEvents: 'none',
			},
			'.FilterSet-optionIndicator': {
				position: 'relative',
				flex: '0 0 auto',
				width: remCalc(30),
				height: remCalc(30),
				borderRadius: '50%',
				border: `1px solid ${getColor('ivory', 700)}`,
				backgroundColor: "transparent",
				transition: 'border-color var(--transition-duration) ease, background-color var(--transition-duration) ease, box-shadow var(--transition-duration) ease',
				'&::after': {
					content: '""',
					position: 'absolute',
					left: '50%',
					top: '50%',
					width: remCalc(8),
					height: remCalc(14),
					border: `2px solid ${getColor('ivory', 800)}`,
					borderTop: 0,
					borderLeft: 0,
					opacity: 0,
					transform: 'translate(-50%, -62%) rotate(45deg)',
					transition: 'opacity 120ms ease',
				},
			},
			'.FilterSet-optionLabel': {
				color: getColor('ivory', 700),
				lineHeight: remCalc(22),
			},
			'&:hover .FilterSet-optionIndicator': {
				borderColor: getColor('ivory', 700),
			},
			'.FilterSet-optionInput:focus-visible + .FilterSet-optionIndicator': {
				outline: `2px solid ${getColor('ivory', 800)}`,
				outlineOffset: remCalc(2),
				boxShadow: `0 0 0 ${remCalc(2)} ${getColor('white', 100)}`,
			},
			'.FilterSet-optionInput:checked + .FilterSet-optionIndicator': {
				borderColor: getColor('ivory', 800),
				backgroundColor: getColor('white', 100),
			},
			'.FilterSet-optionInput:checked + .FilterSet-optionIndicator::after': {
				opacity: 1,
			},
			'.FilterSet-optionInput:checked ~ .FilterSet-optionLabel': {
				color: getColor('ivory', 800),
			},
			'.FilterSet-optionInput:disabled + .FilterSet-optionIndicator': {
				opacity: 0.55,
				cursor: 'not-allowed',
			},
			'.FilterSet-optionInput:disabled ~ .FilterSet-optionLabel': {
				opacity: 0.7,
			},
			'.FilterSet-optionInput:disabled ~ .FilterSet-optionIndicator, .FilterSet-optionInput:disabled ~ .FilterSet-optionLabel': {
				cursor: 'not-allowed',
			},
		},

		'&.FilterSet-isOpen': {
			'.FilterSet-toggleButton': {
				borderColor: getColor('ivory', 500),
			},
		},

		'.FilterSet-filter-isDisabled': {
			opacity: .6,
			cursor: 'not-allowed',
			'*': {
				cursor: 'not-allowed',
			},
		},
	},
};

const styles = {};

export { styles };
export default styles;